// internal
import { ListData } from '@app/store/typings/state/global.d';
import { ZoneData } from '@app/typings/services/zone';

export const KEY_ZONE_FETCH = 'KEY_ZONE_FETCH';
export interface FetchZone {
  type: typeof KEY_ZONE_FETCH;
  payload: {
    brand: string;
    project: string;
  };
}

export const KEY_ZONE_SET_DATA = 'KEY_ZONE_SET_DATA';
export interface SetZones {
  type: typeof KEY_ZONE_SET_DATA;
  payload: {
    data: ZoneData[];
  };
}

export const KEY_ZONE_MODAL_CREATE = 'KEY_ZONE_MODAL_CREATE';
export interface SwitchModalCreate {
  type: typeof KEY_ZONE_MODAL_CREATE;
  payload?: boolean;
}

export const KEY_ZONE_SELECT_FETCH = 'KEY_ZONE_SELECT_FETCH';
export interface FetchSelectZone {
  type: typeof KEY_ZONE_SELECT_FETCH;
  payload: {
    brand: string;
    project: string;
  };
}

export const KEY_ZONE_SELECT_SET_DATA = 'KEY_ZONE_SELECT_SET_DATA';
export interface ZoneSetDataSelect {
  type: typeof KEY_ZONE_SELECT_SET_DATA;
  payload: ListData[];
}

export const KEY_ZONE_CREATE = 'KEY_ZONE_CREATE';
export interface FormCreate {
  type: typeof KEY_ZONE_CREATE;
  payload: {
    brand: string;
    project: string;
    name: string;
  };
}

export type ZoneType =
  | FetchSelectZone
  | ZoneSetDataSelect
  | FetchZone
  | SetZones
  | SwitchModalCreate
  | FormCreate;
